import { globals } from "./globals";
import { ScenariosConfig } from "./interfaces";

export const mapDivEnterToClick = (keyUpEvt: any, onEnterPressed?: () => void) => {
    if(keyUpEvt.key === 'Enter') {
        if(onEnterPressed) {
            onEnterPressed();
        } else {
            $(keyUpEvt.target as any).trigger('click');
        }
    }
}

export const setUp508 = (onGetCurrent508WindowLayer: () => {objects: string[]}) => {
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Tab' || e.which === 9) {
            var current508Layer = onGetCurrent508WindowLayer();
            var lastObj = current508Layer.objects[current508Layer.objects.length - 1]
    
            //508 Window Constraint
            if (e.shiftKey) {
                if (document.activeElement.id === current508Layer.objects[0]) {
                    setFocus(lastObj);
                    e.preventDefault();
                }
            } else {
                if (document.activeElement.id === lastObj) {
                    setFocus(current508Layer.objects[0]);
                    e.preventDefault();
                }
            }
        }
    });
}

export const setFocusImmediate = (id: string, onDone?: (success: boolean) => void) => {
    const el = document.getElementById(id);

    if(el) {
        document.getElementById(id).focus();
        if(onDone) {
            onDone(true);
        }
    } else {
        if(onDone) {
            onDone(false);
        }
    }
}

export const playSound = (audio: string, loopAudio?: boolean, isRelativePath?: boolean) => {
    (window as any)['scenario'].playSound(audio + '.mp3', () => {
        if (loopAudio ) {
            playSound(audio, loopAudio, isRelativePath);
        }
    }, false, globals.isMuted, !isRelativePath);
}

export const setFocus = (id: string, onDone?: (success: boolean) => void) => {
    setTimeout(() => {
        setFocusImmediate(id, onDone);
    }, 250);
}

export const getSaveData = (): ScenariosConfig => {
    var savedData: any = localStorage.getItem('saved-game-medsurg');

    if(savedData) {
        savedData = JSON.parse(savedData);
    } else {
        var newData: ScenariosConfig = {
            avatarIndx: 0,
            scenarios: [
                {
                    scenarioName: 'Level 1',
                    isUnlocked: true,
                    score: 0,
                    badges: [
                        {
                            key: 'ana',
                            title: 'Anaphylaxis',
                            description: '',
                            isUnlocked: false,
                            maxPoints: 1000,
                            lockedImage: './assets/images/general/badges/level1/badge_anaphylaxis_main.png',
                            unlockedImage: './assets/images/general/badges/level1/badge_anaphylaxis_down.png'
                        },
                        {
                            key: 'intra',
                            title: 'Intracranial',
                            description: '',
                            maxPoints: 1000,
                            isUnlocked: false,
                            lockedImage: './assets/images/general/badges/level1/badge_intracranial_pressure_main.png',
                            unlockedImage: './assets/images/general/badges/level1/badge_intracranial_pressure_down.png'
                        },
                        {
                            key: 'splene',
                            title: 'Splenectomy',
                            maxPoints: 1000,
                            description: '',
                            isUnlocked: false,
                            lockedImage: './assets/images/general/badges/level1/badge_splenectomy_main.png',
                            unlockedImage: './assets/images/general/badges/level1/badge_splenectomy_down.png'
                        },
                        {
                            key: 'turp',
                            title: 'Turp',
                            description: '',
                            isUnlocked: false,
                            maxPoints: 1000,
                            lockedImage: './assets/images/general/badges/level1/badge_turp_main.png',
                            unlockedImage: './assets/images/general/badges/level1/badge_turp_down.png'
                        }
                    ]
                },
                {
                    scenarioName: 'Level 2',
                    isUnlocked: false,
                    score: 0,
                    badges: [
                        {
                            key: 'embo',
                            title: 'Air Embolism',
                            description: '',
                            isUnlocked: false,
                            maxPoints: 1000,
                            lockedImage: './assets/images/general/badges/level2/badge_air_embolism_main.png',
                            unlockedImage: './assets/images/general/badges/level2/badge_air_embolism_down.png'
                        },
                        {
                            key: 'tube',
                            title: 'Chest Tube',
                            description: '',
                            maxPoints: 1000,
                            isUnlocked: false,
                            lockedImage: './assets/images/general/badges/level2/badge_chest_tube_main.png',
                            unlockedImage: './assets/images/general/badges/level2/badge_chest_tube_down.png'
                        },
                        {
                            key: 'hysto',
                            title: 'Diagnostic Hysteroscopy',
                            maxPoints: 1000,
                            description: '',
                            isUnlocked: false,
                            lockedImage: './assets/images/general/badges/level2/badge_diagnostic_hysteroscopy_main.png',
                            unlockedImage: './assets/images/general/badges/level2/badge_diagnostic_hysteroscopy_down.png'
                        },
                        {
                            key: 'sep',
                            title: 'Sepsis',
                            description: '',
                            isUnlocked: false,
                            maxPoints: 1000,
                            lockedImage: './assets/images/general/badges/level2/badge_sepsis_main.png',
                            unlockedImage: './assets/images/general/badges/level2/badge_sepsis_down.png'
                        }
                    ]
                }
            ]
        };
        savedData = newData;
    }

    return savedData;
}

export const saveGame = (data: ScenariosConfig): void => {
    localStorage.setItem('saved-game-medsurg', JSON.stringify(data));
}
